import { LinkedLoginNudge } from '@/components/linkedin-settings/Nudge';
import { ExtensionNudge } from '@/design-system/extension-nudge';
import {
  GoogleReconnectNudge,
  MicrosoftReconnectNudge,
  CalendarReconnectNudge,
} from '@/design-system/reconnect-nudge';
import { TrialNudge } from '@/design-system/trial-nudge';
import { useCheckExtensionInstalled } from '@/hooks/use-check-extension-installed';
import { useLocation } from 'react-router-dom';
import { useMailBox } from '@/hooks/use-mailbox';
import { useIsExternalUser } from '@/hooks/useIsExternalUser';
import { useAuth } from '@/hooks';
// import { IsExternalNudge } from '@/components/nudges';

export const Nudges = () => {
  const { currUser } = useAuth();
  const { pathname } = useLocation();
  const isExternalUser = useIsExternalUser();
  const extResult = useCheckExtensionInstalled();
  const isFlowsRoute = pathname?.slice(1, 6) === 'flows';
  const isInterviewRoute = pathname?.slice(1, 11) === 'interviews';

  const { isMailBoxConnected, isCalConnected } = useMailBox();

  const { status = {}, installed } = extResult || {};
  const { login_li_pub, login_li_rec } = status;
  const { li_settings = {} } = status;
  const { email, notification, notifFrequency, allMessageNotification } =
    li_settings;

  const {
    account,
    google_auth_error_code: googleAuthErrorCode,
    ms_auth_error_code: msAuthErrorCode,
  } = currUser || {};

  const { gcal: gcalErrorCode, mscal: mscalErrorCode } =
    currUser?.auth_error_code || {};

  const { status: accountStatus } = account || {};

  const liSettingPreCheck = installed && login_li_pub && login_li_rec;

  const hasLiSettingsConfigured =
    email !== false &&
    notification !== false &&
    notifFrequency !== false &&
    allMessageNotification !== false;

  const nudgeConfig = [
    {
      condition: accountStatus === 'trial',
      component: TrialNudge,
    },
    {
      condition: !installed && !isFlowsRoute,
      component: ExtensionNudge,
    },
    {
      condition: liSettingPreCheck && !hasLiSettingsConfigured,
      component: LinkedLoginNudge,
    },
    {
      condition:
        !isMailBoxConnected &&
        googleAuthErrorCode >= 400 &&
        googleAuthErrorCode <= 500,
      component: GoogleReconnectNudge,
    },
    {
      condition:
        !isMailBoxConnected && msAuthErrorCode >= 400 && msAuthErrorCode <= 500,
      component: MicrosoftReconnectNudge,
    },
    {
      condition:
        !isCalConnected && gcalErrorCode >= 400 && gcalErrorCode <= 500,
      component: CalendarReconnectNudge,
      props: { variant: 'gcal' },
    },
    {
      condition:
        !isCalConnected && mscalErrorCode >= 400 && mscalErrorCode <= 500,
      component: CalendarReconnectNudge,
      props: { variant: 'mscal' },
    },
  ];

  const renderNudges = nudgeConfig.filter((item) => item.condition);

  return (
    <>
      {isExternalUser || isInterviewRoute ? null : ( // <IsExternalNudge />
        <>
          {renderNudges.map((item, index) => {
            const Component = item.component;
            const { props = {} } = item;
            return <Component key={index} {...props} />;
          })}
        </>
      )}
    </>
  );
};
